import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import {
  CreateButton,
  Datagrid,
  EditButton,
  FunctionField,
  List,
  NumberField,
  SimpleList,
  TopToolbar,
} from "react-admin";
import { checkPermission } from "server/security/utils";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { DoctoralSchoolFeeCategoryChoices } from "utils/choices";

const categoryLabel = category =>
  DoctoralSchoolFeeCategoryChoices.find(c => c.id === category)?.name ?? "—";

const ListActions = ({ hasCreate }) => <TopToolbar>{hasCreate && <CreateButton />}</TopToolbar>;

const ListDoctoralSchoolFees = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  return (
    <List
      title="Такси за докторантско училище"
      exporter={false}
      actions={
        <ListActions
          hasCreate={checkPermission(userPermissions, permissions.canCreateDoctoralSchoolCampaigns)}
        />
      }
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => categoryLabel(record.category)}
          secondaryText={record => (
            <>
              <MobileListRow fields={[{ label: "Година", value: record.year }]} />
              <MobileListRow fields={[{ label: "Такса", value: record.amount }]} />
            </>
          )}
        />
      ) : (
        <Datagrid
          rowClick={false}
          bulkActionButtons={false}
          empty={<EmptyList />}
        >
          <NumberField source="year" label="Година" sortable={false} options={{ useGrouping: false }} />
          <FunctionField label="Категория" render={record => categoryLabel(record.category)} />
          <NumberField source="amount" label="Такса" sortable={false} />
          <EditButton label="Редакция" />
        </Datagrid>
      )}
    </List>
  );
};

export default ListDoctoralSchoolFees;
